var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnarchiveItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 9.99995C12.4 9.99995 12.7 10.1 12.8 10.2L15.8 12.6999C16.2 13.0999 16.3 13.7 15.9 14.1C15.5 14.5 14.9 14.5999 14.5 14.1999L12.1 12.1999L9.69996 14.1999C9.29996 14.5999 8.59996 14.4999 8.29996 14.0999C7.89996 13.6999 7.99996 12.9999 8.39996 12.6999L11.4 10.2C11.7 10.1 12 9.99995 12.2 9.99995Z",
    fill: "#EBEBEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 10C12.8 10 13.2 10.4 13.2 11L13.2 17C13.2 17.6 12.8 18 12.2 18C11.6 18 11.2 17.6 11.2 17L11.2 11C11.2 10.5 11.6 10 12.2 10Z",
    fill: "#EBEBEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3 22H4.7C3.2 22 2 20.8 2 19.3V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V19.3C22 20.8 20.8 22 19.3 22ZM4 8V19.3C4 19.7 4.3 20 4.7 20H19.3C19.7 20 20 19.7 20 19.2V8H4Z",
    fill: "#EBEBEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8H2.99998C2.59998 8 2.29998 7.8 2.09998 7.4C1.89998 7 1.99998 6.7 2.19998 6.4L4.89998 2.8C5.29998 2.3 5.89998 2 6.49998 2H17.5C18.1 2 18.7 2.3 19.1 2.8L21.8 6.4C22 6.7 22.1 7.1 21.9 7.4C21.7 7.8 21.4 8 21 8ZM4.99998 6H19L17.5 4H6.49998L4.99998 6Z",
    fill: "#EBEBEA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchiveItem);
export default __webpack_public_path__ + "static/media/UnarchiveItem.249002ce54415de8247d6d2aff502607.svg";
export { ForwardRef as ReactComponent };